import React, { memo } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { Text } from '@redlink/components/atoms';

export const DrawerItem = memo(
  ({
    icon,
    label,
    labelStyle,
    focused = false,
    activeTintColor = '#f4354c',
    inactiveTintColor = '#545454',
    style,
    onPress,
    ...rest
  }) => {
    const color = focused ? activeTintColor : inactiveTintColor;
    const iconNode = icon ? icon({ size: 24, focused, color }) : null;

    return (
      <View collapsable={false} {...rest} style={[styles.container, style]}>
        {focused && (
          <View
            style={[styles.indicator, { backgroundColor: activeTintColor }]}
          />
        )}
        <TouchableOpacity onPress={onPress} style={styles.wrapper}>
          <>
            {iconNode}
            <View>
              {typeof label === 'string' ? (
                <Text
                  numberOfLines={1}
                  style={[
                    {
                      color,
                    },
                    labelStyle,
                  ]}
                >
                  {label}
                </Text>
              ) : (
                label({ color, focused })
              )}
            </View>
          </>
        </TouchableOpacity>
      </View>
    );
  }
);

const styles = StyleSheet.create({
  container: {
    overflow: 'hidden',
    height: 80,
    justifyContent: 'center',
  },
  wrapper: {
    alignItems: 'center',
  },
  indicator: {
    ...StyleSheet.absoluteFillObject,
    width: 6,
  },
  proItemContainer: {
    position: 'absolute',
    left: 35,
    bottom: 15,
  },
});
